import type { Dictionary } from '../types';

export const en: Dictionary = {
  doc_title: 'BITSECURE — Information security audits & penetration testing for business',

  nav_services: 'Services',
  nav_why: 'Why us',
  nav_process: 'Process',
  nav_contact: 'Contacts',
  nav_cta: 'Get a consultation',

  hero_h1: 'Business protection you can trust',
  hero_lead:
    'BITSECURE performs independent audits and penetration testing, finding weaknesses in your systems before they are exploited. Clear reports, concrete recommendations, strict confidentiality.',
  hero_cta1: 'Get a consultation →',
  hero_cta2: 'Our services',
  hero_note: 'We work under contract and NDA · first consultation is free',

  chip1_t: 'Audit passed',
  chip1_s: '0 critical',
  chip2_t: 'NDA',
  chip2_s: 'confidential',
  chip3_t: 'Report + plan',
  chip3_s: 'clear steps',

  trust1_l: 'tests performed',
  trust2_l: 'industries & companies',
  trust3_l: 'NDA compliance',
  trust4_l: 'support after the audit',

  svc_h2: 'Comprehensive security assessment',
  svc_p:
    'A full range of services — from a focused application audit to a large-scale simulation of a targeted attack on your company.',

  why_h2: 'A partner, not a contractor',
  why_p: 'We own the outcome: we find real risks and help you close them.',

  proc_h2: 'A clear process at every stage',

  std_lab: 'We follow recognised <b>international testing methodologies</b>',

  contact_h2: "Let's talk about your business security",
  contact_p:
    "Get in touch with our team — we'll assess your needs and agree on scope and timeline. The first consultation is free.",

  foot_tagline: 'Independent information security audits and penetration testing for business.',
  foot_services: 'Services',
  foot_company: 'Company',
  foot_connect: 'Connect',
  foot_s1: 'Web applications',
  foot_s2: 'External perimeter',
  foot_s3: 'Red Team',
  foot_s4: 'Source code audit',
  foot_s5: 'Social engineering',
  foot_rights: '© 2025 BITSECURE. All rights reserved.',
  foot_privacy: 'Privacy policy',
  foot_offer: 'Terms of service',

  pop_title: 'Get in touch',
  pop_sub: 'Pick a channel that suits you — we reply fast.',

  order: 'Order',

  form_title: 'Request a quote',
  form_sub: "Fill in the form — we'll reply within a day.",
  f_company: 'Company name',
  f_email: 'Email address',
  f_method: 'Preferred contact method',
  f_m_tg: 'Telegram',
  f_m_phone: 'Phone',
  f_m_wa: 'WhatsApp',
  f_contact_tg: 'Telegram username',
  f_contact_phone: 'Phone number',
  f_contact_wa: 'WhatsApp number',
  f_service: 'Service of interest',
  f_comments: 'Additional comments',
  f_submit: 'Send request',
  f_succ_t: 'Request sent!',
  f_succ_s: "Thank you! We'll get in touch shortly.",
  f_close: 'Close',

  ch_phone_t: 'Phone',
  ch_phone_s: 'on request',
  ch_wa_s: 'quick reply',

  services: [
    ['Web applications', 'We find vulnerabilities in web apps using the OWASP methodology — before attackers do.'],
    ['External perimeter', 'We test the resilience of your external infrastructure against intrusion from the internet.'],
    ['Internal network', 'We model an insider attack: what an intruder could do once inside your network.'],
    ['Red Team', "A full simulation of a real targeted attack — testing your team's and processes' readiness."],
    ['Mobile applications', 'iOS and Android audit: data storage, business logic, API security.'],
    ['Source code audit', 'We find vulnerabilities and flaws at the code level — static analysis and manual review.'],
    ['Wireless networks', 'Wi-Fi testing for traffic interception and unauthorized access.'],
    ['Social engineering', 'We test employees against phishing and manipulation, exposing gaps in your policies.'],
    ['Consulting & processes', 'We build secure workflows and a data protection strategy.'],
  ],
  why: [
    ['01', 'Confidentiality', 'Strict NDA compliance and protection of client data at every stage.'],
    ['02', 'Expert knowledge', "Experienced specialists apply advanced techniques and a real attacker's mindset."],
    ['03', 'Actionable recommendations', 'Concrete remediation steps — a clear action plan, not an abstract report.'],
    ['04', 'Tailored approach', 'We adapt scenarios to your infrastructure, risks and resources.'],
  ],
  steps: [
    ['01', 'Needs analysis', 'We analyse requirements, assets and goals in detail to choose the right approach.'],
    ['02', 'Solution design', 'We build a tailored strategy and testing scenarios.'],
    ['03', 'Execution & support', 'We carry out the work and support remediation of the issues found.'],
    ['04', 'Feedback', 'We continuously improve our services based on results and client needs.'],
  ],
};
